<template>

    <!-- SIDEBAR -->
    <div class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-end border-black-40 hp-border-color-dark-80 " >
        <div class="hp-sidebar-container ">
            <div class="hp-sidebar-header-menu">
                <div class="row justify-content-between align-items-end mx-0">
                    <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-visible">
                        <div class="hp-cursor-pointer">
                            <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                    fill="#B2BEC3"></path>
                                <path
                                    d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                    fill="#B2BEC3"></path>
                            </svg>
                        </div>
                    </div>

                    <div class="w-auto px-0">
                        <div class="hp-header-logo d-flex align-items-center">

                            <a href="#" class="position-relative" v-if="noUserName == 'noUserName'">


                                <img class="hp-logo hp-sidebar-visible hp-dark-none" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-logo hp-sidebar-visible hp-dark-block" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-none"
                                    src="@/assets/img/logo_long_black.png" alt="logo" style="width: 150px;">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block"
                                    src="@/assets/img/favicon.png" alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none"
                                    src="@/assets/img/favicon.png" alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block"
                                    src="@/assets/img/favicon.png" alt="logo">
                            </a>

                            <router-link :to="{ name: 'home' }" class="position-relative" v-else>


                                <img class="hp-logo hp-sidebar-visible hp-dark-none" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-logo hp-sidebar-visible hp-dark-block" src="@/assets/img/favicon.png"
                                    alt="logo">
                                <img class="hp-log hp-sidebar-hidden hp-dir-none hp-dark-none"
                                    src="@/assets/img/logo_long_black.png" alt="logo" style="width: 150px;" >
                                <img class="hp-log hp-sidebar-hidden hp-dir-none hp-dark-block"
                                    src="@/assets/img/logo_long_white2.png" alt="logo" style="width: 150px;">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none"
                                    src="@/assets/img/favicon.png" alt="logo">
                                <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block"
                                    src="@/assets/img/favicon.png" alt="logo">
                            </router-link>

                            <a href="javascript;;" target="_blank" class="d-flex">
                                <span
                                    class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1"></span>
                            </a>
                        </div>
                    </div>

                    <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden">
                        <div class="hp-cursor-pointer mb-4" style="margin-top: -45px;">
                            <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                    fill="#B2BEC3"></path>
                                <path
                                    d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                    fill="#B2BEC3"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <ul style="margin-top: 25px;">
                    <li >

                        <ul v-if="noUserName == 'noUserName'">
                            

                            <li style="margin-top: 30px;">
                                <div>
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="post" data-bs-original-title="post"
                                        aria-label="post"></div>



                                    <router-link :to="{name: 'sign-in'}">

                                        <button class="btn btn-primary btn-outline-primary w-100"
                                        style="color: #fff; font-size: larger; padding-left: 40px; padding-right: 40px; padding-top: 12px; padding-bottom: 12px;">
                                        
                                            Sign in

                                        </button>

                                    </router-link>

                                </div>
                            </li>

                            <li style="margin-top: 0px;">
                                <div>
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="post" data-bs-original-title="post"
                                        aria-label="post"></div>

                                    <router-link :to="{name: 'sign-up'}">

                                        <button class="btn w-100  text-primary"
                                        style="color: #fff; font-size: larger; padding-left: 40px; padding-right: 40px; padding-top: 12px; padding-bottom: 12px; color: #9146ff !important; background-color: transparent">
                                        
                                            Sign up

                                        </button>

                                    </router-link>

                                    
                                </div>
                            </li>


                        </ul>

                        <ul v-else>
                            <li >
                                <router-link :to="{ name: 'home' }" id="homeN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Home" data-bs-original-title="Home"
                                        aria-label="Home"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Home" style="font-size: 18px;"></i>
                                        </span>


                                        <span class="titleS">Home</span>
                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'explore' }" id="exploreN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Explore"
                                        data-bs-original-title="Explore" aria-label="Explore"></div>


                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Discovery" style="font-size: 18px;" ></i>
                                        </span>

                                        <span class="titleS">Explore
                                            
                                        </span>

                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'notifications' }" id="notiN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Notifications"
                                        data-bs-original-title="Notifications" aria-label="Notifications"></div>


                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Notification" style="font-size: 18px;" ></i>
                                        </span>

                                        <span class="titleS">Notifications
                                            <span v-if="notiCount > 0"
                                                class="badge rounded-circle  bg-primary-1 hp-bg-dark-primary text-white ms-8"
                                                style="border-color: #9146ff; background-color: #9146ff !important;   padding: 5px 8px 5px 8px; text-align: center; font-size: 10px; border-radius: 50%;"
                                                > {{ notiCount }} 
                                            </span>
                                        </span>

                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'messages' }" id="messageN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Messages" data-bs-original-title="Messages"
                                        aria-label="messages"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Message" style="font-size: 18px;"></i>
                                        </span>


                                        <span class="titleS">Messages</span>

                                        <span v-if="msgCount > 0"
                                                class="badge rounded-circle  bg-primary-1 hp-bg-dark-primary text-white ms-8"
                                                style="border-color: #9146ff;  padding: 5px 8px 5px 8px; text-align: center; font-size: 10px; border-radius: 50%; background-color: #9146ff !important;"
                                                > {{ msgCount }} 
                                            </span>

                                        

                                    </span>
                                </router-link>
                            </li>

                            <li class="d-none" v-if="userType == 'model' ">
                                <router-link :to="{name: 'collections'}"  id="collectionN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Collections"
                                        data-bs-original-title="Collections" aria-label="collections"></div>
                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark" style="font-size: 18px;"></i>
                                        </span>

                                        <span class="titleS">Collections</span>
                                    </span>

                                    
                                </router-link>

                                
                            </li>

                            <li v-else >
                                <router-link :to="{name: 'collections'}"  id="collectionN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Collections"
                                        data-bs-original-title="Collections" aria-label="collections"></div>
                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Bookmark" style="font-size: 18px;"></i>
                                        </span>

                                        <span class="titleS">Collections</span>
                                    </span>

                                    
                                </router-link>

                                
                            </li>

                            <li>
                                <router-link :to="{ name: 'subscriptions' }" id="subN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Subscriptions"
                                        data-bs-original-title="Subscriptions" aria-label="Subscriptions"></div>

                                    <span>

                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Heart" style="font-size: 18px;"></i>
                                        </span>

                                        <span class="titleS">Subscriptions</span>
                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <router-link :to="{ name: 'payments' }" id="paymentN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Payments" data-bs-original-title="Payments"
                                        aria-label="Payments"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Wallet" style="font-size: 18px;"></i>
                                        </span>



                                        <span class="titleS">Wallet</span>
                                    </span>
                                </router-link>
                            </li>

                            <li v-if="userType == 'model'">
                                <router-link :to="{ name: 'earnings' }" id="payoutN">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="Earnings" data-bs-original-title="Earnings"
                                        aria-label="Earnings"></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-Chart" style="font-size: 18px;"></i>
                                        </span>


                                        <span class="titleS">Earnings</span>
                                    </span>
                                </router-link>
                            </li>

                            <li>
                                <a href="javascript:;" role="button" id="moreN" data-bs-toggle="dropdown">
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="More..." data-bs-original-title="More..."
                                        aria-label="More..."></div>

                                    <span>
                                        <span class="submenu-item-icon">
                                            <i class="hp-text-color-dark-0 iconly-Light-MoreSquare" style="font-size: 18px;"></i>
                                        </span>


                                        <span class="titleS">More</span>
                                    </span>
                                </a>

                                <!-- <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item" href="javascript:;">Action</a></li>
                                        <li><a class="dropdown-item" href="javascript:;">Something else here</a></li>
                                    </ul> -->

                                <ul class="dropdown-menu" style=" cursor: pointer;">

                                    <li>
                                        <router-link :to="{ name: 'profile' }" class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-user-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">My
                                                Profile</span>
                                        </router-link>
                                    </li>

                                    <li v-if="userType == 'model'">
                                        <router-link :to="{ name: 'collections' }" class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-bookmark-line" style="font-size: 20px;" ></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Collections </span>
                                        </router-link>
                                    </li>

                                    <li>
                                        <router-link :to="{ name: 'referral' }" class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-team-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;"> Referrals </span>
                                        </router-link>
                                    </li>

                                    <li v-if="userType == 'user'">
                                        <router-link :to="{ name: 'kyc' }" class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-user-star-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Become a
                                                Model </span>
                                        </router-link>
                                    </li>

                                    

                                    <li>
                                        <a class="dropdown-item dp-hov" data-bs-toggle="modal" data-bs-target="#support">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-question-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Help and
                                                Support</span>
                                        </a>
                                    </li>

                                    <li style="display: none;">

                                        <a @click="setToDark" v-if="mode == 'light'" href="#"
                                            class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-moon-clear-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Dark
                                                Mode</span>

                                        </a>

                                        <a @click="setToLight" v-else href="#" class="dropdown-item dp-hov">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-sun-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Light
                                                Mode</span>


                                        </a>

                                    </li>



                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>

                                    <li>
                                        <a href="#" class="dropdown-item dp-hov" @click="handleSignOut">
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 ri-2 ri-logout-box-line" style="font-size: 20px;"></i>
                                            </span>

                                            <span class="titleS"
                                                style="text-align: start; width: 100%; padding-right: 50px;">Sign
                                                out</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>

                            <li style="margin-top: 20px;" v-if="userType == 'model'">
                                <div>
                                    <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                        data-bs-placement="right" title="post" data-bs-original-title="post"
                                        aria-label="post"></div>



                                    <button class="btn btn-primary" id="postBtn"
                                        style="color: #fff; font-size: larger; padding-left: 40px; padding-right: 40px; padding-top: 12px; padding-bottom: 12px;"
                                        data-bs-toggle="modal" data-bs-target="#createModal">
                                        Create
                                        <i class="hp-text-color-dark-0 iconly-Light-Plus"
                                            style="padding-left: 30px; color: #fff;"></i>

                                        <!-- <i class="hp-text-color-dark-0 iconly-Light-PaperPlus" style="padding-left: 30px;"></i> -->
                                    </button>

                                    <button id="postBtn2" class="btn btn-icon-only rounded-circle btn-primary"
                                        data-bs-toggle="modal" data-bs-target="#createModal" style="display: none;">
                                        <i class="hp-text-color-dark-0  ri-add-fill"
                                            style="color: #fff; font-size: 20px;"></i>
                                    </button>
                                </div>
                            </li>


                        </ul>

                    </li>


                </ul>

            </div>

            <div v-if="noUserName == 'noUserName'"></div>
            <div v-else class="row justify-content-between align-items-center hp-sidebar-footer mx-0 hp-bg-color-dark-90">
                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>

                <div class="col">
                    <div class="row align-items-center">
                        <div class="w-auto px-0">
                            <router-link :to="{ name: 'profile' }">
                                <img :src="profilePic"
                                    style="width: 58px; height: 58px; border-width: 0px; border-radius: 50%;  object-fit: cover; border-color: #000; border-width: 1px; border-style: solid;"
                                    class="hp-img-cover">
                            </router-link>
                        </div>

                        <div class="w-auto ms-8 px-0 hp-sidebar-hidden mt-4">
                            <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS">{{
                                fullName }}</span>
                            <a href="javascript:;" class="hp-badge-text fw-normal hp-text-color-dark-30">@{{ userName
                                }}</a>
                        </div>
                    </div>
                </div>

                <div class="col hp-flex-none w-auto px-0 hp-sidebar-hidden">
                    <router-link :to="{ name: 'profile' }">

                        <div>
                            <i class="hp-text-color-dark-0 hp-text-color-black-80 iconly-Light-Setting"></i>
                        </div>

                    </router-link>
                </div>
            </div>
        </div>
    </div>

    <!-- MOBILE NAV -->
    <div class="offcanvas offcanvas-start hp-mobile-sidebar bg-black-20 hp-bg-dark-90" tabindex="-1" id="mobileMenu"
        aria-labelledby="mobileMenuLabel" style="width: 256px; z-index: 9999;">

        <div v-if="noUserName == 'noUserName'"></div>
        <div v-else class="offcanvas-header justify-content-between align-items-center ms-16 me-8 mt-16 p-0">
            <div class="w-auto px-12" style="margin-top: 10px; ">
                <div class="hp-header-logo d-flex align-items-center">
                    <div class="col"
                        style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; width: 100%;">
                        <div class="row align-items-center">
                            <div class="w-auto px-0">
                                <router-link :to="{ name: 'profile' }">
                                    <img :src="profilePic"
                                        style="width: 58px; height: 58px; border-width: 0px; border-radius: 50%;  object-fit: cover; border-color: #000; border-width: 1px; border-style: solid;"
                                        class="hp-img-cover">
                                </router-link>
                            </div>


                        </div>
                        <div class="w-auto  px-0 hp-sidebar-hidden mt-8" style="margin-left: -8px;">
                            <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS"
                                style="font-weight: 900;">{{ fullName }}</span>
                            <router-link :to="{ name: 'profile' }"
                                class="hp-badge-text fw-normal hp-text-color-dark-30">@{{ userName }}</router-link>
                        </div>
                    </div>



                </div>
            </div>

            <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden" data-bs-dismiss="offcanvas"
                aria-label="Close" style="position: absolute; top: 30px; right: 10px;">
                <button type="button" class="btn btn-text btn-icon-only bg-transparent">
                    <i class="ri-close-fill lh-1 hp-text-color-black-80" style="font-size: 24px;"></i>
                </button>
            </div>
        </div>

        <div v-if="noUserName == 'noUserName'"></div>
        <router-link v-else :to="{ name: 'user-lists' }" style="color: #000;">

            <div style="margin-top: 20px; display: flex; justify-content: flex-start; align-items: center; width: 100%; padding-left: 20px; margin-bottom: -10px; z-index: 99;"
                class="d-flex ">

                

                <div class="d-flex" v-if="userType == 'model'">
                    <p class="hp-page-content titleS" style="font-weight: 900;">{{ kFormatter(fanCount) }}</p>
                    <p class="hp-page-content titleS" style="margin-left: 10px; font-weight: 400 !important; ">Fans</p>
                </div>

                <div class="d-flex"  v-else>
                    <p class="hp-page-content titleS" style="font-weight: 900;">{{ kFormatter(followingCount) }}</p>
                    <p class="hp-page-content titleS" style="margin-left: 10px; font-weight: 400 !important;">Following
                    </p>
                </div>

                <div class="d-flex" >
                    <p class="hp-page-content titleS " style="font-weight: 900; margin-left: 20px; ">{{ kFormatter(followersCount) }}</p>
                    <p class="hp-page-content " style="margin-left: 10px; font-weight: 400 !important; ">Followers</p>
                </div>

                



            </div>

        </router-link>

        
        <div
            class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-end border-black-40 hp-border-color-dark-80">
            <div class="hp-sidebar-container">
                <div class="hp-sidebar-header-menu">
                    <div class="row justify-content-between align-items-end mx-0">
                        <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-visible">
                            <div class="hp-cursor-pointer">
                                <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                        fill="#B2BEC3"></path>
                                    <path
                                        d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                        fill="#B2BEC3"></path>
                                </svg>
                            </div>
                        </div>

                        
                        <div class="w-auto px-0">
                            <div class="hp-header-logo d-flex align-items-center">
                                <router-link :to="{ name: 'home' }" class="position-relative">
                                    <div class="hp-header-logo-icon position-absolute bg-black-20 hp-bg-dark-90 rounded-circle border border-black-0 hp-border-color-dark-90 d-flex align-items-center justify-content-center"
                                        style="width: 18px; height: 18px; top: -5px;">
                                        <svg class="hp-fill-color-dark-0" width="12" height="12" viewBox="0 0 12 12"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M0.709473 0L1.67247 10.8L5.99397 12L10.3267 10.7985L11.2912 0H0.710223H0.709473ZM9.19497 3.5325H4.12647L4.24722 4.88925H9.07497L8.71122 8.95575L5.99397 9.70875L3.28047 8.95575L3.09522 6.87525H4.42497L4.51947 7.93275L5.99472 8.33025L5.99772 8.3295L7.47372 7.93125L7.62672 6.21375H3.03597L2.67897 2.208H9.31422L9.19572 3.5325H9.19497Z"
                                                fill="#2D3436" />
                                        </svg>
                                    </div>

                                    <img class="hp-logo hp-sidebar-visible hp-dark-none" src="@/assets/img/favicon.png"
                                        alt="logo">
                                    <img class="hp-logo hp-sidebar-visible hp-dark-block" src="@/assets/img/favicon.png"
                                        alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-none"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none"
                                        src="@/assets/img/favicon.png" alt="logo">
                                    <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block"
                                        src="@/assets/img/favicon.png" alt="logo">
                                </router-link>

                                <a href="javascript;;" target="_blank" class="d-flex">
                                    <span
                                        class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                                </a>
                            </div>
                        </div>

                        <div class="w-auto px-0 hp-sidebar-collapse-button hp-sidebar-hidden">
                            <div class="hp-cursor-pointer mb-4">
                                <svg width="8" height="15" viewBox="0 0 8 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.91102 1.73796L0.868979 4.78L0 3.91102L3.91102 0L7.82204 3.91102L6.95306 4.78L3.91102 1.73796Z"
                                        fill="#B2BEC3"></path>
                                    <path
                                        d="M3.91125 12.0433L6.95329 9.00125L7.82227 9.87023L3.91125 13.7812L0.000224113 9.87023L0.869203 9.00125L3.91125 12.0433Z"
                                        fill="#B2BEC3"></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <ul style="margin-top: 30px;">
                        <li>

                            <div v-if="noUserName == 'noUserName'" style="margin-top: 100px">
                                <router-link :to="{name: 'sign-in'}" style="margin-top: 100px;">
                                    <button class="btn btn-primary w-100">Sign in</button>
                                </router-link>

                                <br><br>

                                <router-link :to="{name: 'sign-up'}" style="padding-top: 10px;">
                                    <button class="btn w-100" style="color: #9146ff !important; background-color: transparent !important;">Sign up</button>
                                </router-link>
                            </div>

                            <ul v-else>
                                <li>
                                    <router-link :to="{ name: 'home' }" id="homeN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Home" data-bs-original-title="Home"
                                            aria-label="Home"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Home" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Home</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'explore' }" id="exploreN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Explore" data-bs-original-title="Explore"
                                            aria-label="Explore"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Discovery" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Explore</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'notifications' }" id="notiN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Notifications"
                                            data-bs-original-title="Notifications" aria-label="noti"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Notification" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Notifications
                                                <span v-if="notiCount > 0"
                                                    class="badge rounded-circle  bg-primary-1 hp-bg-dark-primary text-white ms-8"
                                                style="border-color: #9146ff;  padding: 5px 8px 5px 8px; text-align: center; font-size: 10px; border-radius: 50%; background-color: #9146ff !important;"
                                                    > {{ notiCount }} 
                                                </span>
                                            </span>

                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'messages' }" id="messageN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Messages" data-bs-original-title="Messages"
                                            aria-label="messages"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Message" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Messages</span>

                                            <span v-if="msgCount > 0"
                                                class="badge rounded-circle  bg-primary-1 hp-bg-dark-primary text-white ms-8"
                                                style="border-color: #9146ff;  padding: 5px 8px 5px 8px; text-align: center; font-size: 10px; border-radius: 50%; background-color: #9146ff !important;"
                                                > {{ msgCount }} 
                                            </span>

                                        </span>
                                    </router-link>
                                </li>

                                <li class="d-none" v-if="userType == 'model'">
                                    <router-link :to="{name: 'collections'}" id="collectionN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Collections"
                                            data-bs-original-title="Collections" aria-label="Collections"></div>
                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark" style="font-size: 18px;" ></i>
                                            </span>

                                            <span class="titleS">Collections</span>
                                        </span>

                                        
                                    </router-link>

                                    
                                </li>

                                <li v-else>
                                    <router-link :to="{name: 'collections'}" id="collectionN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Collections"
                                            data-bs-original-title="Collections" aria-label="Collections"></div>
                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark" style="font-size: 18px;" ></i>
                                            </span>

                                            <span class="titleS">Collections</span>
                                        </span>

                                        
                                    </router-link>

                                    
                                </li>

                                <li>
                                    <router-link :to="{ name: 'subscriptions' }" id="subN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Subscriptions"
                                            data-bs-original-title="Subscriptions" aria-label="Subscriptions"></div>

                                        <span>

                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Heart" style="font-size: 18px;" ></i>
                                            </span>

                                            <span class="titleS">Subscriptions</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>
                                    <router-link :to="{ name: 'payments' }" id="paymentN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Payments" data-bs-original-title="Payments"
                                            aria-label="Payments"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Wallet" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Wallet</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li v-if="userType == 'model'">
                                    <router-link :to="{ name: 'earnings' }" id="payoutN2">
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Earnings" data-bs-original-title="Earnings"
                                            aria-label="Earnings"></div>

                                        <span>
                                            <span class="submenu-item-icon">
                                                <i class="hp-text-color-dark-0 iconly-Light-Chart" style="font-size: 18px;" ></i>
                                            </span>


                                            <span class="titleS">Earnings</span>
                                        </span>
                                    </router-link>
                                </li>

                                <li>

                                    <div class="btn-group dropup" style="width: 100%;">
                                        <!-- START -->
                                        <a href="javascript:;" style="width: 100%;" class="dropup" role="button"
                                            data-bs-toggle="dropdown" id="moreN2">
                                            <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                                data-bs-placement="right" title="More..."
                                                data-bs-original-title="More..." aria-label="More..."></div>

                                            <span>
                                                <span class="submenu-item-icon">
                                                    <i class="hp-text-color-dark-0 iconly-Light-MoreSquare" style="font-size: 18px;" ></i>
                                                </span>


                                                <span class="titleS">More</span>
                                            </span>
                                        </a>

                                        <ul class="dropdown-menu" style=" cursor: pointer;">

                                            <li>
                                                <router-link :to="{ name: 'profile' }" class="dropdown-item dp-hov">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-user-line" style="font-size: 20px;" ></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">My
                                                        Profile</span>
                                                </router-link>
                                            </li>

                                            <li v-if="userType == 'model'">
                                                <router-link :to="{name: 'collections'}" class="dropdown-item dp-hov"> 
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-bookmark-line" style="font-size: 20px;"></i>
                                                    </span>
                                                            
                                                    <span class="titleS" style="text-align: start; width: 100%; padding-right: 50px;">Collections</span>
                                                </router-link>
                                            </li>

                                            <li >
                                                <router-link :to="{name: 'referral'}" class="dropdown-item dp-hov"> 
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-team-line" style="font-size: 20px;"></i>
                                                    </span>
                                                            
                                                    <span class="titleS" style="text-align: start; width: 100%; padding-right: 50px;">Referrals</span>
                                                </router-link>
                                            </li>

                                            <li v-if="userType == 'user'">
                                                <router-link :to="{ name: 'kyc' }"
                                                    class="dropdown-item dp-hov">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-user-star-line" style="font-size: 20px;" ></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">Become
                                                        a Model </span>
                                                </router-link>
                                            </li>

                                            <li>
                                                <a class="dropdown-item dp-hov" data-bs-toggle="modal" data-bs-target="#support">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-question-line" style="font-size: 20px;"></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">Help and
                                                        Support</span>
                                                </a>
                                            </li>

                                            <li style="display: none;">
                                                <a @click="setToDark" v-if="mode == 'light'" href="#"
                                                    class="dropdown-item dp-hov">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-moon-clear-line" style="font-size: 20px;" ></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">Dark
                                                        Mode</span>


                                                </a>

                                                <a @click="setToLight" v-else href="#" class="dropdown-item dp-hov">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-sun-line" style="font-size: 20px;"></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">Light
                                                        Mode</span>


                                                </a>
                                            </li>



                                            <li>
                                                <hr class="dropdown-divider">
                                            </li>

                                            <li>
                                                <a href="#" class="dropdown-item dp-hov" @click="handleSignOut">
                                                    <span class="submenu-item-icon">
                                                        <i class="hp-text-color-dark-0 ri-2 ri-logout-box-line" style="font-size: 20px;"></i>
                                                    </span>

                                                    <span class="titleS"
                                                        style="text-align: start; width: 100%; padding-right: 50px;">Sign
                                                        out</span>
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- END -->
                                    </div>

                                </li>


                                <li style="margin-top: 40px;" v-if="userType == 'model'">
                                    <div>
                                        <div class="tooltip-item in-active" data-bs-toggle="tooltip"
                                            data-bs-placement="right" title="Post" data-bs-original-title="Post"
                                            aria-label="Post"></div>



                                        <button class="btn btn-primary " id="postBtn" 
                                            style="color: #fff; font-size: larger; padding-left: 40px; padding-right: 40px; padding-top: 12px; padding-bottom: 12px; font-weight: 900;"
                                            data-bs-toggle="modal" data-bs-target="#createModal">
                                            Create
                                            <i class="hp-text-color-dark-0 iconly-Light-Plus"
                                                style="padding-left: 30px; color: #fff;"></i>

                                            <!-- <i class="hp-text-color-dark-0 iconly-Light-PaperPlus" style="padding-left: 30px;"></i> -->
                                        </button>

                                        <button class="btn btn-icon-only rounded-circle btn-primary"
                                            data-bs-toggle="modal" data-bs-target="#createModal" style="display: none;">
                                            <i class="hp-text-color-dark-0  ri-add-fill"
                                                style="color: #fff; font-size: 20px;"></i>
                                        </button>
                                    </div>
                                </li>


                            </ul>

                        </li>


                    </ul>
                </div>


            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <div style="position: relative;">

                                <p class="hp-p1-body mb-0" style="margin-top: 10px; position: absolute; bottom: 22px; font-size: 11px; font-weight: 800; width: 100%; text-align: center; color: #9146ff;" id="progressM">  </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- CREATE -->
    <div class="modal fade" id="createModal" tabindex="-1" aria-labelledby="createModal" aria-hidden="true" style="z-index: 99999;">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header py-16">
                    <h4 class="modal-title" id="createModalLabel" style="text-align: center; width: 100%;">New post</h4>
                    <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal" aria-label="Close">
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>
                </div>

                <div class="divider my-0"></div>

                <div class="modal-body py-48">
                    <form @submit.prevent="submitPost">
                        <div class="row" style="padding-left: 20px; padding-right: 20px;">

                            <video  src="" id="videoGif" muted style="display:none;"></video>
                            <canvas id="canvasGif" style="display:none;"></canvas>
                            
                            <!-- LEFT -->
                            <div class="col-12 col-lg-6">

                                <div class="mb-24">
                                    <label class="form-label">Preview / Thumbnail</label>
                                    <p class="hp-badge-text mt-0">Add a custom preview image for your post.</p>
                                    <!-- main DUPLI IMG -->
                                    <img src="@/assets/img/imggs.png" alt=""
                                        style="width: 80px; border-radius: 5px; margin-bottom: 5px; margin-right: 5px; object-fit: cover;"
                                        id="previewImgPre">

                                    <input type="file" class="form-control" accept="image/*" hidden id="previewSelect"
                                        @change="thumbImagePreview">
                                    <label for="previewSelect" class="form-label" style="cursor: pointer;">
                                        <i class="hp-text-color-dark-0 iconly-Light-PaperPlus"></i>
                                    </label>


                                </div>

                                <div class="mb-24">
                                    <label class="form-label">Upload media</label>
                                    <p class="hp-badge-text mt-0" style="line-height: 16px;">Add images or videos.
                                        Maximum of 10 files. File size limit for each file is 20(MB) for images and
                                        500(MB) for videos</p>


                                    <!-- dud imgs -->
                                    <div class="d-flex align-items-center" style="flex-wrap: wrap;">

                                        <!-- DUD -->
                                        <div id="dudDiv">
                                            <img src="@/assets/img/imggs.png" alt=""
                                                style="width: 80px; border-radius: 5px; margin-bottom: 5px; margin-right: 5px;"
                                                id="dudImg1">
                                            <img src="@/assets/img/imggs.png" alt=""
                                                style="width: 80px; border-radius: 5px; margin-bottom: 5px; margin-right: 5px;"
                                                id="dudImg2">
                                        </div>

                                        <!-- RL -->
                                        <div v-for="media in fMediaUrlList" :key="media.id"
                                            style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                            <!-- IMG -->
                                            <div v-if="media.fileType.startsWith('image')">
                                                <img :src="media.fileUrl" alt=""
                                                    style="width: 90px; height: 90px; object-fit: cover; border-radius: 5px; cursor: pointer;"
                                                    @click="playMedia(media)">

                                                <i @click="deleteMedia(media)" style="cursor: pointer;"
                                                    class="hp-text-color-dark-0 color-danger ri-delete-bin-5-fill position-absolute top-0 start-85"></i>

                                                <p v-if="media.fileSize > 20485760"
                                                    class="hp-input-description color-danger"
                                                    style="text-align: center; margin-top: 5px;">{{ media.fileSizeD }}
                                                </p>

                                                <p v-else class="hp-input-description"
                                                    style="text-align: center; margin-top: 5px;">{{ media.fileSizeD }}
                                                </p>
                                            </div>

                                            <div v-else >

                                                <video  
                                                    style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover; position: relative; pointer-events: none;" >
                                                    <source :src="media.fileUrl" type="video/mp4">
                                                    <source :src="media.fileUrl" type="video/ogg">
                                                    <source :src="media.fileUrl" type="video/webm">
                                                    <source :src="media.fileUrl" type="video/3gp">
                                                    <source :src="media.fileUrl" type="video/quicktime">
                                                    Your browser does not support the video tag.

                                                </video>

                                                <i @click="playMedia(media)"
                                                    class="hp-text-color-dark-0 position-absolute ri-2x ri-play-circle-fill"
                                                    style="color: #fff; top: 25%; left: 35%; cursor: pointer;"></i>

                                                <i @click="deleteMedia(media)" style="cursor: pointer;"
                                                    class="hp-text-color-dark-0 color-danger ri-delete-bin-5-fill position-absolute top-0 start-85"></i>

                                                <p v-if="media.fileSize > 524288000"
                                                    class="hp-input-description color-danger"
                                                    style="text-align: center; margin-top: 5px;">{{ media.fileSizeD }}
                                                </p>

                                                <p v-else class="hp-input-description"
                                                    style="text-align: center; margin-top: 5px;">{{ media.fileSizeD }}
                                                </p>
                                            </div>

                                        </div>

                                        <input type="file" class="form-control" accept="video/*,image/*" hidden
                                            id="mediaSelect" multiple @change="mediaPreview">
                                        <label for="mediaSelect" class="form-label" style="cursor: pointer;">
                                            <i class="hp-text-color-dark-0 iconly-Light-PaperPlus"></i>
                                        </label>

                                    </div>

                                </div>

                                <div class="mb-24 mm-none">

                                    <!-- BUTTON -->
                                    <button class="btn btn-primary "
                                        style=" margin-top: 30px; padding-top: 15px; padding-bottom: 15px; color: #ffffff;">Post</button>

                                </div>

                            </div>

                            <!-- RIGHT -->
                            <div class="col-12 col-lg-6">

                                <div class="mb-24">
                                    <label for="orderDetails" class="form-label">Caption <span
                                            class="text-danger me-4">*</span> </label>
                                    <textarea name="orderDetails" id="orderDetails" class="form-control" rows="4"
                                        placeholder="Type here..."
                                        maxlength="300" required v-model="caption" style="line-height: 20px; padding: 10px;"></textarea>
                                </div>

                                <div class="mb-24">
                                    <label class="form-label">Content rating <span class="text-danger me-4">*</span> </label>
                                    <p class="hp-badge-text mt-0" style=" line-height: 16px;">Mark content as safe (SFW) or adult (NSFW)</p>

                                    <!-- <select class="form-select" aria-label="category" id="category" >

                                        <option value="sfw">SFW</option>
                                        <option value="nsfw">NSFW</option>

                                    </select> -->

                                    
                                    <div class="tabs" style="margin-top: -20px; ">
                                        <div class="tab-group" >
                                            <input checked="" id="tab1" name="tab" v-model="category" value="sfw" type="radio" />
                                            <label for="tab1">
                                            <span style="font-size: 11px;"> 🌿 SFW </span>
                                            </label>
                                        </div>
                                        <div class="tab-group">
                                            <input id="tab2" name="tab" v-model="category" value="nsfw" type="radio" />
                                            <label for="tab2">
                                            <span style="font-size: 11px;"> 🔥 NSFW</span>
                                            </label>
                                        </div>
                                    
                                    </div>

                                </div>

                                <!-- <div class="mb-24">
                                    <label class="form-label">Tags</label>
                                    <textarea style="line-height: 20px" class="form-control" rows="2"
                                        placeholder="#cosplay, #asmr, #nsfw..." v-model="tags"
                                        maxlength="300"></textarea>
                                </div> -->


                                <div class="mb-24" v-if="userType == 'model'" >
                                    <label class="form-label" style="margin-top: 20px;">Visibility <span class="text-danger me-4">*</span> </label>
                                    <p class="hp-badge-text mt-0" style="line-height: 16px;">Who can see this post</p>
                                    
                                    <!-- <select class="form-select" aria-label="post type" required v-model="postType">

                                        <option value="free">Subscribers</option>
                                        <option value="paid">PPV</option>

                                    </select> -->

                                    <div class="tabs" style="margin-top: -20px; ">
                                        <div class="tab-group" >
                                            <input checked="" id="tab3" name="tabx" v-model="postType" value="free" type="radio" />
                                            <label for="tab3">
                                            <span style="font-size: 11px;"> Subscribers </span>
                                            </label>
                                        </div>
                                        <div class="tab-group">
                                            <input id="tab4" name="tabx" v-model="postType" value="paid" type="radio" />
                                            <label for="tab4">
                                            <span style="font-size: 11px;"> PPV</span>
                                            </label>
                                        </div>
                                        <div class="tab-group">
                                            <input id="tab5" name="tabx" v-model="postType" value="freex" type="radio" />
                                            <label for="tab5">
                                            <span style="font-size: 11px;"> Free </span>
                                            </label>
                                        </div>
                                    
                                    </div>

                                    
                                </div>

                                <div class="mb-24" v-if="userType == 'model' && postType == 'paid'">

                                    <label class="form-label">Price</label>
                                    <div class="input-group mb-16">
                                    <span class="input-group-text" >&#8358;</span>
                                    <input type="number" class="form-control" placeholder="0.00"  aria-label="Username" aria-describedby="basic-addon1" v-model="price">
                                    </div>

                                </div>

                            </div>

                            <div class="col-12 dd-none">

                                <!-- BUTTON -->
                                <button class="btn btn-primary "
                                    style=" margin-top: 30px; padding-top: 15px; padding-bottom: 15px; color: #ffffff;">Post</button>

                            </div>


                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- SHOW -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 9999999;" class="loadingModalBg"
        ref="showModal">
        <div class="col-12 col-xl-12 shx">
            <div class="card hp-card-6">
                <div class="card-body" style="position: relative;">

                    <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        style="position:absolute; top:20px; right: 20px;" @click="closeShow">
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>

                    <div class="row">

                        <h4 style="text-align: center;">{{ singleMediaName }}</h4>

                        <div style="display: flex; justify-content: center; align-items: center;">

                            <video controls v-if="singleMediaType.startsWith('video')" class="shm">
                                <source :src="singleMediaUrl" type="video/mp4">
                                <source :src="singleMediaUrl" type="video/ogg">
                                <source :src="singleMediaUrl" type="video/webm">
                                <source :src="singleMediaUrl" type="video/3gp">
                                <source :src="singleMediaUrl" type="video/quicktime">
                                Your browser does not support the video tag.

                            </video>

                            <img :src="singleMediaUrl" alt="" class="shm" v-else>



                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SUPPORT -->
     <div class="modal fade" id="support" tabindex="-1" aria-labelledby="supportLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Need help with anything?</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Send us a message and we will get back to you as soon as possible. You could also email us directly at <a href="mailto:help@baesnap.com" target="_blank" style="color: #9146ff;">help@baesnap.com</a> </p>


                    <div class="divider mt-18 mb-18"></div>

                    <form>

                        <div class="mb-24" style="margin-top: 20px;">
                            <label for="exampleInputEmail1" class="form-label">Phone number</label>
                            <input type="tel" class="form-control"  aria-describedby="emailHelp"
                                placeholder="Your phone number" v-model="supportPhone">

                        </div>

                        <div class="mb-24">
                            <label for="exampleInputEmail1" class="form-label">Message</label>
                            <textarea class="form-control" v-model="supportMessage" cols="30" rows="4" maxlength="300" placeholder="Your message" required></textarea>

                        </div>


                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal" style="color: #000 !important;">Close</button>
                            <button class="btn btn-primary">Send message</button>
                        </div>

                    </form>


                </div>

                


            </div>
        </div>
    </div>

    <!-- CREATE POP -->
    <div style="z-index: 10; position: fixed; bottom: 40px; right: 25px;" v-if="userType == 'model'" class="d-none" >
        <button data-bs-toggle="modal" data-bs-target="#createModal"  class="btn btn-icon-only rounded-circle btn-primary" style="width: 55px; height: 55px;">
            <i class="hp-text-color-dark-0 ri-2x ri-add-line"></i>
        </button>
    </div>

    <!-- BOTTOM NAV -->
    <nav class="bottom-nav" v-if="pageName != 'messages'" :class="{ 'nav-hidden': isNavHidden }" >

        <div class="nav-pill">

            <button class="nav-item active" aria-label="Home" @click="page1">
                <i class="hp-text-color-dark-0 iconly-Bold-Home" style="font-size: 22px;" v-if="pageName == 'home'"></i>
                <i class="hp-text-color-dark-0 iconly-Light-Home" style="font-size: 22px;" v-else></i>
            </button>

            <button class="nav-item"  aria-label="notification" style="position: relative;" @click="page2">

                <i class="hp-text-color-dark-0 iconly-Bold-Notification" style="font-size: 22px;" v-if="pageName == 'notifications'" ></i>
                <i class="hp-text-color-dark-0 iconly-Light-Notification" style="font-size: 22px;" v-else ></i>

                <span v-if="notiCount > 0" class="position-absolute translate-middle p-2 rounded-circle bg-primary hp-notification-circle" style="width: 8px; height: 8px; top: 14px; right: 22px;"></span>

            </button>

            <button class="nav-item"  aria-label="Swap" style="position: relative;" @click="page3">

                <i class="hp-text-color-dark-0 iconly-Bold-Chat" style="font-size: 22px;" v-if="pageName == 'messages'" ></i>
                <i class="hp-text-color-dark-0 iconly-Light-Chat" style="font-size: 22px;" v-else ></i>

                <span v-if="msgCount > 0" class="position-absolute translate-middle p-2 rounded-circle bg-primary hp-notification-circle" style="width: 8px; height: 8px; top: 14px; right: 22px;"></span>
            </button>

            <button class="nav-item" aria-label="Discover" @click="page4">
                <i class="hp-text-color-dark-0 iconly-Bold-Wallet" style="font-size: 22px;" v-if="pageName == 'payments'" ></i>
                <i class="hp-text-color-dark-0 iconly-Light-Wallet" style="font-size: 22px;" v-else ></i>
            </button>

        </div>

        <button class="search-button" aria-label="Search" data-bs-toggle="modal" data-bs-target="#createModal" v-if="userType == 'model'" >
            <i class="hp-text-color-dark-0 ri-2x ri-add-line" ></i>
        </button>

    </nav>
    


</template>

<style scoped>
.btn {
    color: #fff !important;
}

.shx {
    width: 1000px;
}

.shm {
    max-width: 800px;
    max-height: 500px;
    object-fit: cover;
}

/* RADIO */
.tabs {
  display: flex;
  gap: 15px;
  
}

.tab-group input {
  appearance: none;
}

.tab-group label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 85px;
  height: 38px;
  line-height: 1.6;
  border: 1px solid #cccccc;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 300;
  position: relative;
  background-color: transparent;
  transition: all 0.48s cubic-bezier(0.23, 1, 0.32, 1);
}

.tab-group label::after {
  content: "";
  position: absolute;
  bottom: -32px;
  left: 50%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #9146ff;
  transform: translateX(-50%);
  transform-origin: 0 0;
  scale: 0;
  opacity: 0;
  z-index: -1;
  transition: all 0.48s 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}

.tab-group label::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 50%;
  width: 85px;
  height: 38px;
  border-radius: 10px;
  background-color: #9146ff;
  transform: translate(-50%, -50%);
  z-index: -1;
  opacity: 0;
  scale: 0;
  transform-origin: 0 0;
  transition: all 0.48s cubic-bezier(0.23, 1, 0.32, 1);
}

.tab-group label:hover {
  border-color: #9146ff;
  color: #9146ff;
}

.tab-group input:checked + label {
  border-color: transparent;
  color: #ffffff;
  scale: 1.1;
}

.tab-group input:checked + label::after {
  bottom: -16px;
  opacity: 1;
  scale: 1;
  box-shadow:
    0rem 6px 13px rgba(10, 60, 255, 0.1),
    0rem 24px 24px rgba(10, 60, 255, 0.09),
    0rem 55px 33px rgba(10, 60, 255, 0.05),
    0rem 97px 39px rgba(10, 60, 255, 0.01),
    0rem 152px 43px rgba(10, 60, 255, 0);
}

.tab-group input:checked + label::before {
  opacity: 1;
  scale: 1;
  top: 50%;
  box-shadow:
    0rem 6px 13px rgba(10, 60, 255, 0.1),
    0rem 24px 24px rgba(10, 60, 255, 0.09),
    0rem 55px 33px rgba(10, 60, 255, 0.05),
    0rem 97px 39px rgba(10, 60, 255, 0.01),
    0rem 152px 43px rgba(10, 60, 255, 0);
}

/* BOTTOM NAV */

/* Bottom navigation wrapper */
.bottom-nav {
  position: fixed;
  left: 50%;
  bottom: 10px !important;
  transform: translateX(-50%);

  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px !important;

  z-index: 1000;

  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.bottom-nav.nav-hidden {
  transform: translate(-50%, calc(100% + 30px));

  transition-duration: 0.3s;
}

/* Main pill */
.nav-pill {
  height: 64px;
  width: 385px;

  padding: 0px;

  display: flex;
  align-items: center;
  justify-content: space-around;

  /* Glass */
  background: rgba(255, 255, 255);


  border-radius: 44px;

  
  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.09),
    0 5px 15px rgba(0, 0, 0, 0.09),
    inset 0 1px 1px rgba(255, 255, 255, 0.95),
    inset 0 -1px 1px rgba(255, 255, 255, 0.25);

  
}


/* Individual nav button */
.nav-item {
  width: 86px;
  height: 54px;

  border: none;
  border-radius: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;

  cursor: pointer;

   transition:
    background 0.25s ease,
    border 0.25s ease,
    box-shadow 0.25s ease,
    transform 0.18s ease;
}

.search-button {
  width: 64px;
  height: 64px;

  border-radius: 50%;

  border: 1px solid #eeeeee;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  /* Glass */
  background: rgba(255, 255, 255);

  box-shadow:
    0 18px 45px rgba(0, 0, 0, 0.09),
    0 5px 15px rgba(0, 0, 0, 0.09),
    inset 0 1px 1px rgba(255, 255, 255, 0.95),
    inset 0 -1px 1px rgba(255, 255, 255, 0.25);

  backdrop-filter: blur(12px);

  transition: background 0.2s ease;
}


@media only screen and (max-width: 666px) {

    .shx {
        width: 350px;

    }

    .shm {
        max-width: 300px;
        max-height: 300px;
        object-fit: cover;
    }

    .bottom-nav {
        width: calc(100% - 28px);
        bottom: 14px;
        gap: 10px;
        display: flex;
    }

    .nav-pill {
        flex: 1;
        width: auto;
        height: 64px;
        border-radius: 40px;
        padding-left: 3px;
    }

    .nav-item {
        width: 72px;
        height: 58px;
        border-radius: 40px;
    }

    .search-button {
        width: 64px;
        height: 64px;
        flex-shrink: 0;
    }

}
</style>

<script>

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject, uploadBytes, uploadString } from "firebase/storage";
import { getAuth, onAuthStateChanged, signOut, signInWithEmailAndPassword } from "firebase/auth"
import { db } from '@/firebase';
import axios from "axios";

import Compressor from 'compressorjs';

export default {

    data() {
        return {

            isLoggedIn: false,
            profilePic: "",
            fullName: "",
            userName: "",
            fanCount: "",
            followingCount: "",
            followersCount: "",
            likes: "",
            email: "",
            loadingText: "",
            errorText: "",
            successText: "",
            mediaRawList: [],
            mediaUrlList: [],
            singleMediaName: "",
            singleMediaType: "",
            singleMediaUrl: "",

            caption: "",
            category: "sfw",
            tags: "",
            price: "",
            postType: "free",

            postRefId: "",
            userType: "",

            mode: "",
            notiCount: 0,
            msgCount: 0,
            msgList:[],

            notiSub: null,

            supportPhone: "",
            supportMessage: "",
            supportCount: 0,

            profileType: "",
            noUserName: "",

            previewName: "default",
            previewUrl: "https://www.baesnap.com/images/pback2.png",
            pageName: "",

            isNavHidden: false,

            lastScrollY: 0,

            scrollThreshold: 10
        }
    },

    computed: {
        fMediaUrlList() {

            for (let i = 0; i < this.mediaUrlList.length; i++) {
                this.mediaUrlList[i].id = "fileNumber" + i;
                this.mediaUrlList[i].number = i;
            }

            return this.mediaUrlList;

        }
    },

    beforeUnmount(){
        if(this.notiSub != null){
            this.notiSub();
        }

        window.removeEventListener(
            "scroll",
            this.handleScroll
        );
    },

    mounted() {

        this.autocomplete();
        this.sider();
        //this.carousel();
        this.index();
        this.inputNumber();

        this.getStart();

        if(sessionStorage.getItem("noUserName") == null){
            this.getUserInfo();
            this.getMode();
            this.notiMethod();
        }

        this.pageName = this.$route.name;

        //SCROLL LOGIC
        this.lastScrollY = window.scrollY;

        window.addEventListener(
            "scroll",
            this.handleScroll,
            { passive: true }
        );

    },

    methods: {

        // MODULES
        sider() {
            $(function () {
                // Menu Link
                $(".hp-sidebar-container li a").each(function () {
                    if (window.location.pathname.split("/")[window.location.pathname.split("/").length - 1] == $(this).attr("href")) {
                        $(this).addClass("active")

                        $(this).parents(".submenu-children").slideDown()
                        $(this).parents(".submenu-children").addClass("active")
                        $(this).parents(".submenu-children").prev("a").addClass("active arrow-active")
                    }
                });

                // Menu Dropdown
                $(".hp-sidebar-container li a").click(function () {
                    if ($(this).next(".submenu-children").length) {
                        $(this).toggleClass("arrow-active")
                        $(this).next(".submenu-children").slideToggle(300)
                    }
                });

                // Mobile Button
                $(".hp-mobile-sidebar-button").click(function () {
                    $("body").removeClass("collapsed-active collapse-btn-none")
                });

                // Collapsed
                $(".hp-sidebar .hp-sidebar-collapse-button").click(function () {
                    $("body").toggleClass("collapsed-active")
                    $(".hp-sidebar .submenu-children").slideUp()
                    $(".hp-sidebar li a").removeClass("arrow-active")
                    $(".hp-sidebar .tooltip-item").toggleClass("in-active")



                    if ($("body").hasClass("collapsed-active")) {
                        $(".hp-sidebar .submenu-children").addClass("d-none")
                        document.getElementById("postBtn").style.display = "none";
                        document.getElementById("postBtn2").style.display = "";
                    } else {
                        $(".hp-sidebar .submenu-children").removeClass("d-none")
                        $(".hp-sidebar .submenu-children").css("display", "none")
                        document.getElementById("postBtn").style.display = "";
                        document.getElementById("postBtn2").style.display = "none";
                    }


                });

                if ($("body").hasClass("collapsed-active")) {
                    $(".hp-sidebar .submenu-children").addClass("d-none")
                    $(".hp-sidebar .tooltip-item").removeClass("in-active")


                }

                // Collapsed Menu Dropdown
                let position = "left";
                let sidebarWidth;

                if ($("html").attr("dir") === "rtl") {
                    position = "right";
                }

                $(".hp-sidebar-container li a").mouseenter(function () {
                    if ($("body").hasClass("collapsed-active")) {
                        sidebarWidth = parseInt($(this).parents(".hp-sidebar").width()) + 38;

                        $(".hp-sidebar-dropdown-container").remove();

                        if ($(this).next(".submenu-children").length) {
                            $("body").append(
                                `
                                        <div class="hp-sidebar-dropdown-container position-absolute">
                                            <ul>` +
                                $(this).next(".submenu-children").html() +
                                `</ul>
                                        </div>
                                        `
                            );

                            if ($(this).offset().top + $(".hp-sidebar-dropdown-container").height() > $(window).height()) {
                                $(".hp-sidebar-dropdown-container > ul").css({
                                    maxHeight: "calc(100vh - " + ($(window).height() - $(this).offset().top) + "px)",
                                });

                                $(".hp-sidebar-dropdown-container").css(
                                    "top", $(this).offset().top - $(".hp-sidebar-dropdown-container").height() + 50 + "px"
                                );
                                if (position === "right") {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, (sidebarWidth - 38) + "px"
                                    );
                                } else {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, "calc(" + $(this).offset().left + "px + " + sidebarWidth + "px)"
                                    );
                                }
                            } else {
                                $(".hp-sidebar-dropdown-container > ul").css({
                                    maxHeight: "none",
                                });

                                $(".hp-sidebar-dropdown-container").css(
                                    "top", $(this).offset().top + "px"
                                );
                                if (position === "right") {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, (sidebarWidth - 38) + "px"
                                    );
                                } else {
                                    $(".hp-sidebar-dropdown-container").css(
                                        position, "calc(" + $(this).offset().left + "px + " + sidebarWidth + "px)"
                                    );
                                }
                            }

                            //--

                            let levelNumber;
                            $(".hp-sidebar-dropdown-container li a").mouseenter(function () {
                                if ($(this).next(".submenu-children").length) {
                                    $(this).css("pointer-events", "none");

                                    levelNumber = $(this)
                                        .next(".collapse")
                                        .find(".submenu-children")
                                        .data("level");

                                    $("body").append(
                                        `
                                                <div class="hp-sidebar-dropdown-container position-absolute" data-level="` +
                                        levelNumber +
                                        `">
                                                    <ul>` +
                                        $(this).next(".submenu-children").html() +
                                        `</ul>
                                                </div>
                                                `
                                    );

                                    if ($(this).offset().top + $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").height() > $(window).height()) {
                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "] > ul").css({
                                            maxHeight: "calc(100vh - " + ($(window).height() - $(this).offset().top) + "px)",
                                        });

                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                            "top", $(this).offset().top - $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").height() + 50 + "px"
                                        );

                                        if (position === "right") {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + ($(this).width() + sidebarWidth - 38 + 27) + "px)"
                                            );
                                        } else {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + $(this).offset().left + "px + " + (sidebarWidth - 37) * parseInt(levelNumber) + "px)"
                                            );
                                        }
                                    } else {
                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "] > ul").css({
                                            maxHeight: "none",
                                        });

                                        $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css("top", $(this).offset().top + "px");
                                        if (position === "right") {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + ($(this).width() + sidebarWidth - 38 + 27) + "px)"
                                            );
                                        } else {
                                            $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").css(
                                                position, "calc(" + $(this).offset().left + "px + " + (sidebarWidth - 37) * parseInt(levelNumber) + "px)"
                                            );
                                        }
                                    }
                                } else {
                                    $(".hp-sidebar-dropdown-container li a").css("pointer-events", "all");
                                    $(".hp-sidebar-dropdown-container[data-level=" + levelNumber + "]").remove();
                                }
                            });
                        }
                    } else {
                        $(".hp-sidebar-dropdown-container").remove();
                    }
                });

                $(window).mousemove(function (e) {
                    let menuItem = $(".hp-sidebar-container li a");
                    let dropdownContainer = $(".hp-sidebar-dropdown-container");

                    if (
                        !menuItem.is(event.target) &&
                        !menuItem.has(event.target).length &&
                        !dropdownContainer.is(event.target) &&
                        !dropdownContainer.has(event.target).length
                    ) {
                        $(".hp-sidebar-dropdown-container").remove();
                        $(".hp-sidebar-dropdown-container li a").css("pointer-events", "all");
                    }
                });
            })
        },

        autocomplete() {

            !(function (e) {
                "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery);
            })(function (e) {
                function t(s, i) {
                    var n = function () { };
                    n = {
                        autoSelectFirst: !1,
                        appendTo: "body",
                        serviceUrl: null,
                        lookup: null,
                        onSelect: null,
                        width: "auto",
                        minChars: 1,
                        maxHeight: 300,
                        deferRequestBy: 0,
                        params: {},
                        formatResult: t.formatResult,
                        delimiter: null,
                        zIndex: 9999,
                        type: "GET",
                        noCache: !1,
                        onSearchStart: n,
                        onSearchComplete: n,
                        containerClass: "autocomplete-suggestions",
                        tabDisabled: !1,
                        dataType: "text",
                        lookupFilter: function (e, t, s) {
                            return -1 !== e.value.toLowerCase().indexOf(s);
                        },
                        paramName: "query",
                        transformResult: function (t) {
                            return "string" == typeof t ? e.parseJSON(t) : t;
                        },
                    };
                    (this.element = s),
                        (this.el = e(s)),
                        (this.suggestions = []),
                        (this.badQueries = []),
                        (this.selectedIndex = -1),
                        (this.currentValue = this.element.value),
                        (this.intervalId = 0),
                        (this.cachedResponse = []),
                        (this.onChange = this.onChangeInterval = null),
                        (this.isLocal = this.ignoreValueChange = !1),
                        (this.suggestionsContainer = null),
                        (this.options = e.extend({}, n, i)),
                        (this.classes = {
                            selected: "autocomplete-selected",
                            suggestion: "autocomplete-suggestion",
                        }),
                        this.initialize(),
                        this.setOptions(i);
                }
                var s = {
                    extend: function (t, s) {
                        return e.extend(t, s);
                    },
                    createNode: function (e) {
                        var t = document.createElement("div");
                        return (t.innerHTML = e), t.firstChild;
                    },
                };
                (t.utils = s),
                    (e.Autocomplete = t),
                    (t.formatResult = function (e, t) {
                        var s =
                            "(" +
                            t.replace(
                                RegExp("(\\/|\\.|\\*|\\+|\\?|\\||\\(|\\)|\\[|\\]|\\{|\\}|\\\\)", "g"),
                                "\\$1"
                            ) +
                            ")";
                        return e.value.replace(RegExp(s, "gi"), "<strong>$1</strong>");
                    }),
                    (t.prototype = {
                        killerFn: null,
                        initialize: function () {
                            var s,
                                i = this,
                                n = "." + i.classes.suggestion,
                                o = i.classes.selected,
                                l = i.options;
                            i.element.setAttribute("autocomplete", "off"),
                                (i.killerFn = function (t) {
                                    0 === e(t.target).closest("." + i.options.containerClass).length &&
                                        (i.killSuggestions(), i.disableKillerFn());
                                }),
                                (l.width && "auto" !== l.width) || (l.width = i.el.outerWidth()),
                                (i.suggestionsContainer = t.utils.createNode(
                                    '<div class="' +
                                    l.containerClass +
                                    '" style="position: absolute; display: none;"></div>'
                                )),
                                (s = e(i.suggestionsContainer)).appendTo(l.appendTo).width(l.width),
                                s.on("mouseover.autocomplete", n, function () {
                                    i.activate(e(this).data("index"));
                                }),
                                s.on("mouseout.autocomplete", function () {
                                    (i.selectedIndex = -1), s.children("." + o).removeClass(o);
                                }),
                                s.on("click.autocomplete", n, function () {
                                    i.select(e(this).data("index"), !1);
                                }),
                                i.fixPosition(),
                                window.opera
                                    ? i.el.on("keypress.autocomplete", function (e) {
                                        i.onKeyPress(e);
                                    })
                                    : i.el.on("keydown.autocomplete", function (e) {
                                        i.onKeyPress(e);
                                    }),
                                i.el.on("keyup.autocomplete", function (e) {
                                    i.onKeyUp(e);
                                }),
                                i.el.on("blur.autocomplete", function () {
                                    i.onBlur();
                                }),
                                i.el.on("focus.autocomplete", function () {
                                    i.fixPosition();
                                });
                        },
                        onBlur: function () {
                            this.enableKillerFn();
                        },
                        setOptions: function (t) {
                            var i = this.options;
                            s.extend(i, t),
                                (this.isLocal = e.isArray(i.lookup)) &&
                                (i.lookup = this.verifySuggestionsFormat(i.lookup)),
                                e(this.suggestionsContainer).css({
                                    "max-height": i.maxHeight + "px",
                                    width: i.width + "px",
                                    "z-index": i.zIndex,
                                });
                        },
                        clearCache: function () {
                            (this.cachedResponse = []), (this.badQueries = []);
                        },
                        clear: function () {
                            this.clearCache(), (this.currentValue = null), (this.suggestions = []);
                        },
                        disable: function () {
                            this.disabled = !0;
                        },
                        enable: function () {
                            this.disabled = !1;
                        },
                        fixPosition: function () {
                            var t;
                            "body" === this.options.appendTo &&
                                ((t = this.el.offset()),
                                    e(this.suggestionsContainer).css({
                                        top: t.top + this.el.outerHeight() + "px",
                                        left: t.left + "px",
                                    }));
                        },
                        enableKillerFn: function () {
                            e(document).on("click.autocomplete", this.killerFn);
                        },
                        disableKillerFn: function () {
                            e(document).off("click.autocomplete", this.killerFn);
                        },
                        killSuggestions: function () {
                            var e = this;
                            e.stopKillSuggestions(),
                                (e.intervalId = window.setInterval(function () {
                                    e.hide(), e.stopKillSuggestions();
                                }, 300));
                        },
                        stopKillSuggestions: function () {
                            window.clearInterval(this.intervalId);
                        },
                        onKeyPress: function (e) {
                            if (
                                this.disabled ||
                                this.visible ||
                                40 !== e.keyCode ||
                                !this.currentValue
                            ) {
                                if (!this.disabled && this.visible) {
                                    switch (e.keyCode) {
                                        case 27:
                                            this.el.val(this.currentValue), this.hide();
                                            break;
                                        case 9:
                                        case 13:
                                            if (-1 === this.selectedIndex) return void this.hide();
                                            if (
                                                (this.select(this.selectedIndex, 13 === e.keyCode),
                                                    9 === e.keyCode && !1 === this.options.tabDisabled)
                                            )
                                                return;
                                            break;
                                        case 38:
                                            this.moveUp();
                                            break;
                                        case 40:
                                            this.moveDown();
                                            break;
                                        default:
                                            return;
                                    }
                                    e.stopImmediatePropagation(), e.preventDefault();
                                }
                            } else this.suggest();
                        },
                        onKeyUp: function (e) {
                            var t = this;
                            if (!t.disabled) {
                                switch (e.keyCode) {
                                    case 38:
                                    case 40:
                                        return;
                                }
                                clearInterval(t.onChangeInterval),
                                    t.currentValue !== t.el.val() &&
                                    (0 < t.options.deferRequestBy
                                        ? (t.onChangeInterval = setInterval(function () {
                                            t.onValueChange();
                                        }, t.options.deferRequestBy))
                                        : t.onValueChange());
                            }
                        },
                        onValueChange: function () {
                            var e;
                            clearInterval(this.onChangeInterval),
                                (this.currentValue = this.element.value),
                                (e = this.getQuery(this.currentValue)),
                                (this.selectedIndex = -1),
                                this.ignoreValueChange
                                    ? (this.ignoreValueChange = !1)
                                    : e.length < this.options.minChars
                                        ? this.hide()
                                        : this.getSuggestions(e);
                        },
                        getQuery: function (t) {
                            var s = this.options.delimiter;
                            return s ? ((t = t.split(s)), e.trim(t[t.length - 1])) : e.trim(t);
                        },
                        getSuggestionsLocal: function (t) {
                            var s = t.toLowerCase(),
                                i = this.options.lookupFilter;
                            return {
                                suggestions: e.grep(this.options.lookup, function (e) {
                                    return i(e, t, s);
                                }),
                            };
                        },
                        getSuggestions: function (t) {
                            var s,
                                i = this,
                                n = i.options,
                                o = n.serviceUrl;
                            (s = i.isLocal ? i.getSuggestionsLocal(t) : i.cachedResponse[t]) &&
                                e.isArray(s.suggestions)
                                ? ((i.suggestions = s.suggestions), i.suggest())
                                : i.isBadQuery(t) ||
                                ((n.params[n.paramName] = t),
                                    !1 !== n.onSearchStart.call(i.element, n.params) &&
                                    (e.isFunction(n.serviceUrl) &&
                                        (o = n.serviceUrl.call(i.element, t)),
                                        e
                                            .ajax({
                                                url: o,
                                                data: n.ignoreParams ? null : n.params,
                                                type: n.type,
                                                dataType: n.dataType,
                                            })
                                            .done(function (e) {
                                                i.processResponse(e, t),
                                                    n.onSearchComplete.call(i.element, t);
                                            })));
                        },
                        isBadQuery: function (e) {
                            for (var t = this.badQueries, s = t.length; s--;)
                                if (0 === e.indexOf(t[s])) return !0;
                            return !1;
                        },
                        hide: function () {
                            (this.visible = !1),
                                (this.selectedIndex = -1),
                                e(this.suggestionsContainer).hide();
                        },
                        suggest: function () {
                            if (0 === this.suggestions.length) this.hide();
                            else {
                                var t = this.options.formatResult,
                                    s = this.getQuery(this.currentValue),
                                    i = this.classes.suggestion,
                                    n = this.classes.selected,
                                    o = e(this.suggestionsContainer),
                                    l = "";
                                e.each(this.suggestions, function (e, n) {
                                    l +=
                                        '<div class="' +
                                        i +
                                        '" data-index="' +
                                        e +
                                        '">' +
                                        t(n, s) +
                                        "</div>";
                                }),
                                    o.html(l).show(),
                                    (this.visible = !0),
                                    this.options.autoSelectFirst &&
                                    ((this.selectedIndex = 0), o.children().first().addClass(n));
                            }
                        },
                        verifySuggestionsFormat: function (t) {
                            return t.length && "string" == typeof t[0]
                                ? e.map(t, function (e) {
                                    return { value: e, data: null };
                                })
                                : t;
                        },
                        processResponse: function (e, t) {
                            var s = this.options,
                                i = s.transformResult(e, t);
                            (i.suggestions = this.verifySuggestionsFormat(i.suggestions)),
                                s.noCache ||
                                ((this.cachedResponse[i[s.paramName]] = i),
                                    0 === i.suggestions.length && this.badQueries.push(i[s.paramName])),
                                t === this.getQuery(this.currentValue) &&
                                ((this.suggestions = i.suggestions), this.suggest());
                        },
                        activate: function (t) {
                            var s = this.classes.selected,
                                i = e(this.suggestionsContainer),
                                n = i.children();
                            return (
                                i.children("." + s).removeClass(s),
                                (this.selectedIndex = t),
                                -1 !== this.selectedIndex && n.length > this.selectedIndex
                                    ? ((t = n.get(this.selectedIndex)), e(t).addClass(s), t)
                                    : null
                            );
                        },
                        select: function (e, t) {
                            var s = this.suggestions[e];
                            s &&
                                (this.el.val(s),
                                    (this.ignoreValueChange = t),
                                    this.hide(),
                                    this.onSelect(e));
                        },
                        moveUp: function () {
                            -1 !== this.selectedIndex &&
                                (0 === this.selectedIndex
                                    ? (e(this.suggestionsContainer)
                                        .children()
                                        .first()
                                        .removeClass(this.classes.selected),
                                        (this.selectedIndex = -1),
                                        this.el.val(this.currentValue))
                                    : this.adjustScroll(this.selectedIndex - 1));
                        },
                        moveDown: function () {
                            this.selectedIndex !== this.suggestions.length - 1 &&
                                this.adjustScroll(this.selectedIndex + 1);
                        },
                        adjustScroll: function (t) {
                            var s,
                                i,
                                n = this.activate(t);
                            n &&
                                ((n = n.offsetTop),
                                    (i =
                                        (s = e(this.suggestionsContainer).scrollTop()) +
                                        this.options.maxHeight -
                                        25),
                                    n < s
                                        ? e(this.suggestionsContainer).scrollTop(n)
                                        : n > i &&
                                        e(this.suggestionsContainer).scrollTop(
                                            n - this.options.maxHeight + 25
                                        ),
                                    this.el.val(this.getValue(this.suggestions[t].value)));
                        },
                        onSelect: function (t) {
                            var s = this.options.onSelect;
                            (t = this.suggestions[t]),
                                this.el.val(this.getValue(t.value)),
                                e.isFunction(s) && s.call(this.element, t);
                        },
                        getValue: function (e) {
                            var t,
                                s = this.options.delimiter;
                            return s
                                ? 1 === (s = (t = this.currentValue).split(s)).length
                                    ? e
                                    : t.substr(0, t.length - s[s.length - 1].length) + e
                                : e;
                        },
                        dispose: function () {
                            this.el.off(".autocomplete").removeData("autocomplete"),
                                this.disableKillerFn(),
                                e(this.suggestionsContainer).remove();
                        },
                    }),
                    (e.fn.autocomplete = function (s, i) {
                        return 0 === arguments.length
                            ? this.first().data("autocomplete")
                            : this.each(function () {
                                var n = e(this),
                                    o = n.data("autocomplete");
                                "string" == typeof s
                                    ? o && "function" == typeof o[s] && o[s](i)
                                    : (o && o.dispose && o.dispose(),
                                        (o = new t(this, s)),
                                        n.data("autocomplete", o));
                            });
                    });
            });


        },

        carousel() {
            // Carousel
            new bootstrap.Carousel();

        },

        index() {
            // Scroll to Top
            $(".scroll-to-top").click(function () {
                $(window).scrollTop(0)
            });

            $(window).scroll(function () {
                if ($(this).scrollTop() > (window.innerHeight / 3)) {
                    $(".scroll-to-top").addClass("active")
                } else {
                    $(".scroll-to-top").removeClass("active")
                }
            });

            // Wish Button
            $(".hp-wish-button").click(function () {
                $(this).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger")
                $(this).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90")
            });

            //BOOKMARK BUTTON
            $(".hp-book-button").click(function () {
                $(this).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary")
                $(this).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90")
            });

            // Date Timer (Page Error Coming Soon)
            $(".data-date-timer").each(function () {
                if ($(this).data("date-timer")) {
                    setInterval(() => {
                        let future = Date.parse($(this).data("date-timer")),
                            now = new Date(),
                            diff = future - now,
                            days = Math.floor(diff / (1000 * 60 * 60 * 24)),
                            hours = Math.floor(diff / (1000 * 60 * 60)),
                            mins = Math.floor(diff / (1000 * 60)),
                            secs = Math.floor(diff / 1000),
                            d = days,
                            h = hours - days * 24,
                            m = mins - hours * 60,
                            s = secs - mins * 60;

                        $(this).find("*[data-date-timer-day]").text(d)
                        $(this).find("*[data-date-timer-hours]").text(h)
                        $(this).find("*[data-date-timer-minutes]").text(m)
                        $(this).find("*[data-date-timer-seconds]").text(s)
                    }, 1000);
                }
            });

            // Search (Icon Search)
            $("*[data-search]").keyup(function () {
                let value = $(this).val();
                let patt = new RegExp(value, "i");

                $("*[data-search-item]").each(function () {
                    if (!($(this).find("*[data-search-item-text]").text().search(patt) >= 0)) {
                        $(this).hide();
                    }
                    if (($(this).find("*[data-search-item-text]").text().search(patt) >= 0)) {
                        $(this).show();
                    }
                });
            });

            // Copy Text
            setTimeout(() => {
                $("*[data-copy-click]").each(function () {
                    let itemId = $(this).find("*[data-copy-id]")

                    if ($(this).data("copy-click") === "value") {
                        $(this).find("*[data-copy-click-id]").click(function (e) {
                            if ($(this).data("copy-click-id") === itemId.data("copy-id")) {
                                let copyText = itemId.val();

                                navigator.clipboard.writeText(copyText);
                            }
                        })
                    } else {
                        $(this).find("*[data-copy-click-id]").click(function (e) {
                            if ($(this).data("copy-click-id") === itemId.data("copy-id")) {
                                if (itemId.find("*[data-copy]")) {
                                    navigator.clipboard.writeText(itemId.find("*[data-copy]").data("copy"));
                                } else {
                                    navigator.clipboard.writeText(itemId.text());
                                }
                            }
                        })
                    }
                });
            }, 300);

            // Payment Input Mask
            $('#payment-cardnumber').mask('0000 0000 0000 0000');
            $('#payment-date').mask('00/00');
            $('#payment-cvc').mask('000');
            $('#phone').mask('(000) 000-0000');

            // Tooltip
            let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })

        },

        inputNumber() {
            // Input Number Component
            $(".input-number .input-number-input").focusin(function () {
                $(this).parent().parent().addClass("input-number-focused")
            });

            $(".input-number .input-number-input").focusout(function () {
                $(this).parent().parent().removeClass("input-number-focused")
            });

            $(".input-number .input-number-input").keyup(function () {
                let inputNumberUp = $(this).parents(".input-number").find(".input-number-handler-up"),
                    inputNumberDown = $(this).parents(".input-number").find(" .input-number-handler-down");

                if (Number($(this).val()) >= $(this).attr("max")) {
                    $(this).val($(this).attr("max"))

                    inputNumberUp.addClass("input-number-handler-up-disabled")
                    inputNumberDown.removeClass("input-number-handler-down-disabled")
                } else {
                    inputNumberDown.removeClass("input-number-handler-down-disabled")
                    inputNumberUp.removeClass("input-number-handler-up-disabled")
                }

                if ($(this).val() !== "") {
                    if (Number($(this).val()) <= $(this).attr("min")) {
                        $(this).val($(this).attr("min"))

                        inputNumberDown.addClass("input-number-handler-down-disabled")
                        inputNumberUp.removeClass("input-number-handler-up-disabled")
                    }
                }
            });

            $(".input-number .input-number-handler").click(function () {
                let inputNumberInput = $(this).parents(".input-number").find(".input-number-input"),
                    inputNumberUp = $(this).parents(".input-number").find(".input-number-handler-up"),
                    inputNumberDown = $(this).parents(".input-number").find(".input-number-handler-down"),
                    inputNumberValue = Number(inputNumberInput.val()),
                    inputNumberStep = Number(inputNumberInput.attr("step")) ? Number(inputNumberInput.attr("step")) : 1,
                    inputNumberMin = Number(inputNumberInput.attr("min")),
                    inputNumberMax = Number(inputNumberInput.attr("max"));

                if (!$(this).hasClass("input-number-handler-up-disabled")) {
                    if ($(this).hasClass("input-number-handler-up")) {
                        if (inputNumberValue < inputNumberMax) {
                            inputNumberValue += inputNumberStep;
                            inputNumberDown.removeClass("input-number-handler-down-disabled")
                        }

                        if (inputNumberValue === inputNumberMax) {
                            inputNumberUp.addClass("input-number-handler-up-disabled")
                        }
                    }
                }

                if (!$(this).hasClass("input-number-handler-down-disabled")) {
                    if ($(this).hasClass("input-number-handler-down")) {
                        if (inputNumberValue > inputNumberMin) {
                            inputNumberValue -= inputNumberStep;
                            inputNumberUp.removeClass("input-number-handler-up-disabled")
                        }

                        if (inputNumberValue === inputNumberMin) {
                            inputNumberDown.addClass("input-number-handler-down-disabled")
                        }
                    }
                }

                inputNumberInput.val(inputNumberValue)
            });

        },

        // MAIN
        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

        },

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            this.$router.go();
        },

        closeShow() {
            this.singleMediaName = "";
            this.singleMediaType = "";
            this.singleMediaUrl = "";
            this.$refs.showModal.classList.remove("bg-active");
            return;

        },

        getStart(){

            const auth = getAuth();
            if(sessionStorage.getItem("userName") == null){

                signInWithEmailAndPassword(auth, "forgot@baesnap.com", "forgotPassword")
                .then( async (data) => {
                    this.noUserName = "noUserName";
                    sessionStorage.setItem("noUserName", "noUserName");
                })

            };

            // if(auth.currentUser.uid == "1PeqlbF36USewgWWl68L2qdpg4h1" || sessionStorage.getItem("noUserName") == "noUserName" || auth == null){
            //     this.noUserName = "noUserName";
            //     sessionStorage.setItem("noUserName", "noUserName");
            // }
        },

        async getUserInfo() {

            const auth = getAuth();

            if( auth == null){
                if(this.$route.name == 'other-profile' || this.$route.name == 'post'){
                    return;
                }

                this.$router.push({ name: 'sign-in' });
                return;
            }

            if( sessionStorage.getItem("noUserName") == "noUserName" || auth.currentUser.uid == "1PeqlbF36USewgWWl68L2qdpg4h1"){
                if(this.$route.name == 'other-profile' || this.$route.name == 'post'){
                    return;
                }

                this.$router.push({ name: 'sign-in' });
                return;
            }

            onAuthStateChanged(auth, (user) => {

                if (user) {
                    this.isLoggedIn = true;
                }
                else {

                    if(this.$route.name == 'other-profile' || this.$route.name == 'post'){
                        return;
                    }

                    this.isLoggedIn = false;
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

            });

            if (sessionStorage.getItem("fullName") == null) {

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                sessionStorage.setItem("profilePic", userSnap.data().profilePic);
                sessionStorage.setItem("profileBackground", userSnap.data().profileBackground);
                sessionStorage.setItem("fullName", userSnap.data().name);
                sessionStorage.setItem("userName", userSnap.data().displayId);
                sessionStorage.setItem("fanCount", userSnap.data().fanCount);
                sessionStorage.setItem("followingCount", userSnap.data().followingCount);
                sessionStorage.setItem("followersCount", userSnap.data().followersCount);
                sessionStorage.setItem("likes", userSnap.data().likes);
                sessionStorage.setItem("userType", userSnap.data().type);
                sessionStorage.setItem("email", userSnap.data().email);
                sessionStorage.setItem("emailNoti", userSnap.data().emailNoti);
                sessionStorage.setItem("pushNoti", userSnap.data().pushNoti);
                sessionStorage.setItem("siteNoti", userSnap.data().siteNoti);
                sessionStorage.setItem("bio", userSnap.data().bio);
                sessionStorage.setItem("profileType", userSnap.data().profileType);

            }

            this.profilePic = sessionStorage.getItem("profilePic");
            this.fullName = sessionStorage.getItem("fullName");
            this.userName = sessionStorage.getItem("userName");
            this.fanCount = sessionStorage.getItem("fanCount");
            this.followingCount = sessionStorage.getItem("followingCount");
            this.followersCount = sessionStorage.getItem("followersCount");
            this.likes = sessionStorage.getItem("likes");
            this.userType = sessionStorage.getItem("userType");
            this.email = sessionStorage.getItem("email");
            this.profileType = sessionStorage.getItem("profileType");


        },

        thumbImagePreview() {

            const fileReader = new FileReader();

            if (document.getElementById("previewSelect").files[0] == null) {
                return;
            }

            fileReader.readAsDataURL(document.getElementById("previewSelect").files[0]);
            fileReader.addEventListener("load", function () {
                document.getElementById("previewImgPre").src = this.result;
            });


        },

        mediaPreview() {

            let input = document.getElementById("mediaSelect");
            let mSize;

            const files = input.files
            for (let i = 0; i < files.length; i++) {

                //get size
                if (Number(files[i].size) >= 1073741824) {
                    mSize = (Number(files[i].size) / 1073741824).toFixed(2) + " GB";
                }
                else if (Number(files[i].size) >= 1048576) {
                    mSize = (Number(files[i].size) / 1048576).toFixed(2) + " MB";
                }
                else if (Number(files[i].size) >= 1024) {
                    mSize = (Number(files[i].size) / 1024).toFixed(2) + " KB";
                }

                this.mediaRawList.push(files[i]);
                this.mediaUrlList.push({
                    id: "fileNumber" + i,
                    number: i,
                    fileName: files[i].name,
                    fileType: files[i].type,
                    fileSize: files[i].size,
                    fileSizeD: mSize,
                    fileUrl: URL.createObjectURL(files[i]),
                    rawFile: files[i],
                })
            }

            this.displayCall();

        },

        displayCall() {
            if (this.mediaUrlList.length > 0) {
                document.getElementById("dudDiv").style.display = 'none';
            }
            else {
                document.getElementById("dudDiv").style.display = '';
            }

        },

        deleteMedia(media) {
            this.mediaRawList.splice(media.number, 1);
            this.mediaUrlList.splice(media.number, 1);
            this.displayCall();
        },

        playMedia(media) {

            this.singleMediaName = media.fileName;
            this.singleMediaType = media.fileType;
            this.singleMediaUrl = media.fileUrl;
            this.$refs.showModal.classList.add("bg-active");

        },

        handleSignOut() {

            const auth = getAuth();

            signOut(auth).then(() => {
                sessionStorage.clear();
                this.$router.push({ name: 'sign-in' });
            })
        },

        async submitPost() {

            const auth = getAuth();
            let previewFile = document.getElementById("previewSelect").files[0];

            //start loading
            this.loadingText = "Uploading post...";
            this.$refs.loadingModal.classList.add("bg-active");


            if (this.userType == 'user') {
                this.errorText = "Only verified creators can post content.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if(this.userType == "model"){
                if(this.postType == "paid" && this.price < 1000){
                    this.errorText = "Minimum price for paid content is ₦1,000";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                if(this.postType == "paid" && this.mediaUrlList.length < 1){
                    this.errorText = "Please upload at least 1 image or video for your paid post";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }
            }
            

            if (previewFile != null && previewFile.size > 10971520) {
                this.errorText = "The image preview/thumbnail image is too large. Maximum size for images is 10MB. Please change the image to proceed.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.mediaUrlList.length > 10) {
                this.errorText = "Too many files. Maximum is ten (10) images/videos";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.mediaUrlList.length > 0) {

                // if (previewFile == null) {
                //     this.errorText = "Please select a preview/thumbnail image for your post";
                //     this.$refs.loadingModal.classList.remove("bg-active");
                //     this.$refs.errorModal.classList.add("bg-active");
                //     return;
                // }

                for (let i = 0; i < this.mediaUrlList.length; i++) {

                    if (String(this.mediaUrlList[i].fileType).includes('image')) {

                        if (this.mediaUrlList[i].size > 20971520) {
                            this.errorText = "The image (" + this.mediaUrlList[i].fileName + ") is too large. Maximum size for images is 10MB. Please remove the image or select another image to proceed.";
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            return;
                        }

                    }
                    else if(String(this.mediaUrlList[i].fileType).includes("video")) {

                        console.log(this.mediaUrlList[i].fileType);
                        console.log(this.mediaUrlList[i].size);

                        if (this.mediaUrlList[i].size > 524288000) {
                            this.errorText = "The video (" + this.mediaUrlList[i].fileName + ") is too large. Maximum size for videos is 500MB. Please remove the video or select another video to proceed.";
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            return;
                        }

                    }

                }
            }

            if (this.price == "") {
                this.price = 0;
            }

            if (this.price > 0 && this.userType == 'user') {
                this.errorText = "Only verified models can post paid content.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                this.price = 0;
                return;
            }

            let mId = "post" + Math.floor(1000000000 + Math.random() * 9000000000);
            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs

            //get subscribers
            const postRef = await addDoc(collection(db, "UserPosts"), {

                idD: mId,
                userId: auth.currentUser.uid,
                fullName: this.fullName,
                username: this.userName,
                email: this.email,
                profilePic: this.profilePic,
                previewName: this.previewName,
                previewUrl: this.previewUrl,
                mediaList: [],
                price: this.price,
                caption: this.caption,
                category: this.category,
                tags: this.tags,
                likeCount: 0,
                likedList: [],
                commentCount: 0,
                comments: [],
                bookmarkCount: 0,
                bookmarkList: [],
                subscribers: [],
                timeStamp: serverTimestamp(),
                timeStampN: secs,
                postType: this.postType,
                paidUsers: [],
                profileType: this.profileType 


            });

            this.postRefId = postRef.id;

            const storage = getStorage();

            // UPLOAD PREVIEW
            if (previewFile != null) {

                await this.uploadPreviewFile(storage, previewFile, auth.currentUser.uid, postRef.id);

            }

            //UPLOAD MEDIA
            if (this.mediaUrlList.length > 0) {

                for (var i = 0; i < this.mediaUrlList.length; i++) {

                    let j = i+1;
                    let v = this.mediaUrlList.length;

                    this.loadingText = "Uploading media files ("+j+"/"+v+")..."

                    await this.uploadMediaFile(storage, this.mediaUrlList[i].rawFile, auth.currentUser.uid, postRef.id);

                }

                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {
                    mediaCount: increment(this.mediaUrlList.length),
                });
            }

            const userRef = doc(db, "Users", auth.currentUser.uid);
            await updateDoc(userRef, {
                postCount: increment(1),
            });

            //END
            this.successText = "Your post was uploaded successfully.";
            this.$refs.loadingModal.classList.remove("bg-active");
            this.$refs.successModal.classList.add("bg-active");
            return;

        },

        uploadPreviewFile(storage, imageFile, userId, postId) {

            this.loadingText = "Uploading preview image...";
            document.getElementById("progressM").textContent = "";

            return new Promise(function (resolve, reject) {

                if(imageFile.size > 200000){

                    //compress file
                    new Compressor(imageFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserPosts/Preview/' + userId + '/' + postId + '/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            //Update progress bar
                            uploadTask.on('state_changed',
                                (snapshot) => {
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    let progressD = progress.toFixed(0);
                                    document.getElementById("progressM").textContent = ""+progressD+"%";

                                    // console.log('Upload is ' + progress + '% done');
                                    switch (snapshot.state) {
                                        case 'paused':
                                            //console.log('Upload is paused');
                                            break;
                                        case 'running':
                                            //console.log('Upload is running');
                                            break;
                                    }
                                },
                                (error) => {
                                    switch (error.code) {
                                        case 'storage/unauthorized':
                                            // User doesn't have permission to access the object
                                            break;
                                        case 'storage/canceled':
                                            // User canceled the upload
                                            break;
                                        case 'storage/unknown':
                                            // Unknown error occurred, inspect error.serverResponse

                                            console.log(error.serverResponse);
                                            return;
                                            break;
                                    }
                                },
                                () => {
                                    // Upload completed successfully, now we can get the download URL
                                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                        const postRef = doc(db, "UserPosts", postId);
                                        await updateDoc(postRef, {

                                            previewName: result.name,
                                            previewUrl: downloadURL,

                                        });

                                        setTimeout(resolve, 2000);

                                    });
                                });

                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });

                }
                else{

                    const storageRef = ref(storage, 'UserPosts/Preview/' + userId + '/' + postId + '/' + imageFile.name);
                            const uploadTask = uploadBytesResumable(storageRef, imageFile);

                            //Update progress bar
                            uploadTask.on('state_changed',
                                (snapshot) => {
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    let progressD = progress.toFixed(0);
                                    document.getElementById("progressM").textContent = ""+progressD+"%";
                                    // console.log('Upload is ' + progress + '% done');
                                    switch (snapshot.state) {
                                        case 'paused':
                                            //console.log('Upload is paused');
                                            break;
                                        case 'running':
                                            //console.log('Upload is running');
                                            break;
                                    }
                                },
                                (error) => {
                                    switch (error.code) {
                                        case 'storage/unauthorized':
                                            // User doesn't have permission to access the object
                                            break;
                                        case 'storage/canceled':
                                            // User canceled the upload
                                            break;
                                        case 'storage/unknown':
                                            // Unknown error occurred, inspect error.serverResponse

                                            console.log(error.serverResponse);
                                            return;
                                            break;
                                    }
                                },
                                () => {
                                    // Upload completed successfully, now we can get the download URL
                                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                        const postRef = doc(db, "UserPosts", postId);
                                        await updateDoc(postRef, {

                                            previewName: imageFile.name,
                                            previewUrl: downloadURL,

                                        });

                                        setTimeout(resolve, 500);

                                    });
                                });

                }

            });

        },

        uploadMediaFile(storage, media, userId, postId) {

            document.getElementById("progressM").textContent = "";

            return new Promise(async function (resolve, reject) {

                if (media.type.startsWith("image")) {

                    if(media.size > 200000){

                        new Compressor(media, {
                            quality: 0.6,
                            width: 2024,
                            // The compression process is asynchronous,
                            // which means you have to access the `result` in the `success` hook function.
                            success(result) {

                                const storageRef = ref(storage, 'UserPosts/Media/' + userId + '/' + postId + '/' + result.name);
                                const uploadTask = uploadBytesResumable(storageRef, result);

                                uploadTask.on('state_changed',
                                    (snapshot) => {
                                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                        let progressD = progress.toFixed(0);
                                        document.getElementById("progressM").textContent = ""+progressD+"%";

                                        // console.log('Upload is ' + progress + '% done');
                                        switch (snapshot.state) {
                                            case 'paused':
                                                //console.log('Upload is paused');
                                                break;
                                            case 'running':
                                                //console.log('Upload is running');
                                                break;
                                        }
                                    },
                                    (error) => {
                                        switch (error.code) {
                                            case 'storage/unauthorized':
                                                // User doesn't have permission to access the object
                                                break;
                                            case 'storage/canceled':
                                                // User canceled the upload
                                                break;
                                            case 'storage/unknown':
                                                // Unknown error occurred, inspect error.serverResponse
                                                this.errorText = "Unknown error occured";
                                                this.$refs.loadingModal.classList.remove("bg-active");
                                                this.$refs.errorModal.classList.add("bg-active");
                                                console.log(error.serverResponse);
                                                return;
                                                break;
                                        }
                                    },
                                    () => {
                                        // Upload completed successfully, now we can get the download URL
                                        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                            const postRef = doc(db, "UserPosts", postId);
                                            await updateDoc(postRef, {

                                                mediaList: arrayUnion({
                                                    name: String(result.name),
                                                    type: String(result.type),
                                                    size: result.size,
                                                    url: String(downloadURL),
                                                }),

                                            });

                                            setTimeout(resolve, 500);

                                        });
                                    });

                            },
                            error(err) {
                                console.log(err.message);
                                return;
                            },
                        });

                    }
                    else{

                        const storageRef = ref(storage, 'UserPosts/Media/' + userId + '/' + postId + '/' + media.name);
                                const uploadTask = uploadBytesResumable(storageRef, media);

                                uploadTask.on('state_changed',
                                    (snapshot) => {
                                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                        let progressD = progress.toFixed(0);
                                        document.getElementById("progressM").textContent = ""+progressD+"%";

                                        // console.log('Upload is ' + progress + '% done');
                                        switch (snapshot.state) {
                                            case 'paused':
                                                //console.log('Upload is paused');
                                                break;
                                            case 'running':
                                                //console.log('Upload is running');
                                                break;
                                        }
                                    },
                                    (error) => {
                                        switch (error.code) {
                                            case 'storage/unauthorized':
                                                // User doesn't have permission to access the object
                                                break;
                                            case 'storage/canceled':
                                                // User canceled the upload
                                                break;
                                            case 'storage/unknown':
                                                // Unknown error occurred, inspect error.serverResponse
                                                this.errorText = "Unknown error occured";
                                                this.$refs.loadingModal.classList.remove("bg-active");
                                                this.$refs.errorModal.classList.add("bg-active");
                                                console.log(error.serverResponse);
                                                return;
                                                break;
                                        }
                                    },
                                    () => {
                                        // Upload completed successfully, now we can get the download URL
                                        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                            const postRef = doc(db, "UserPosts", postId);
                                            await updateDoc(postRef, {

                                                mediaList: arrayUnion({
                                                    name: String(media.name),
                                                    type: String(media.type),
                                                    size: media.size,
                                                    url: String(downloadURL),
                                                }),

                                            });

                                            setTimeout(resolve, 500);

                                        });
                                    });

                    }

                    

                }
                else {

                    // let base64Url, thumbnail;
                    // const video = document.getElementById("videoGif");
                    // video.src = URL.createObjectURL(media);
                    // video.currentTime = 2; 

                    // video.addEventListener('loadeddata', () => {
                    //     const canvas = document.getElementById('canvasGif');
                    //     const ctx = canvas.getContext('2d');
                    //     canvas.width = video.videoWidth;
                    //     canvas.height = video.videoHeight;

                        
                    //     ctx.drawImage(video, 0, 0);

                        
                    //     base64Url =  canvas.toDataURL('image/png');

                    //     console.log("DATA URL: "+canvas.toDataURL('image/png'));

                    
                    //     URL.revokeObjectURL(video.src);

                
                    // });

                    // video.play();

                    // let thumbName = Math.floor(Math.random()*90000) + 10000+".png";
                    // const storageRefThumb = ref(storage, 'UserPosts/Media/Thumbnails/' + userId + '/' + postId + '/' + thumbName);
    
                    // try {
                        
                    //     await uploadString(storageRefThumb, base64Url, 'data_url').then((snapshot) => {
                    //         console.log('Uploaded a data_url string!');
                    //     });

                    
                    //     await getDownloadURL(storageRefThumb)
                    //     .then((url) => {
                    //         thumbnail = url;
                    //     })
                    //     .catch((error) => {
                        
                    //     });
                        
                    // } catch (error) {
                    //     console.error('Upload failed:', error);
                    // }
                    
                    //..
                    const storageRef = ref(storage, 'UserPosts/Media/' + userId + '/' + postId + '/' + media.name);
                    const uploadTask = uploadBytesResumable(storageRef, media);
                    //Update progress bar
                    uploadTask.on('state_changed',
                        (snapshot) => {
                            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                            let progressD = progress.toFixed(0);
                            document.getElementById("progressM").textContent = ""+progressD+"%";

                            // console.log('Upload is ' + progress + '% done');
                            switch (snapshot.state) {
                                case 'paused':
                                    //console.log('Upload is paused');
                                    break;
                                case 'running':
                                    //console.log('Upload is running');
                                    break;
                            }
                        },
                        (error) => {
                            switch (error.code) {
                                case 'storage/unauthorized':
                                    // User doesn't have permission to access the object
                                    break;
                                case 'storage/canceled':
                                    // User canceled the upload
                                    break;
                                case 'storage/unknown':
                                    // Unknown error occurred, inspect error.serverResponse
                                    this.errorText = "Unknown error occured";
                                    this.$refs.loadingModal.classList.remove("bg-active");
                                    this.$refs.errorModal.classList.add("bg-active");
                                    console.log(error.serverResponse);
                                    return;
                                    break;
                            }
                        },
                        () => {
                            // Upload completed successfully, now we can get the download URL
                            getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                const postRef = doc(db, "UserPosts", postId);
                                await updateDoc(postRef, {

                                    mediaList: arrayUnion({
                                        name: String(media.name),
                                        type: String(media.type),
                                        size: media.size,
                                        url: String(downloadURL)+"#t=0.1",                                        
                                    }),

                                    

                                });

                                
                                setTimeout(resolve, 1000);

                            });
                        });

                }

            });

        },

        async getGifFromVideo(media){

            
            const video = document.getElementById("videoGif");
            video.src = URL.createObjectURL(media);
            video.currentTime = 2; // Start from the beginning

            video.addEventListener('loadeddata', () => {
                const canvas = document.getElementById('canvasGif');
                const ctx = canvas.getContext('2d');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                // Draw the video frame to the canvas
                ctx.drawImage(video, 0, 0);

                // Convert the canvas to a data URL and set it as the source for the poster image
                // const posterImage = document.getElementById('posterImage');
                thumbnail =  canvas.toDataURL('image/png');

                //console.log("DATA URL"+canvas.toDataURL('image/png'));

                // Clean up
                URL.revokeObjectURL(video.src);

        
            });

            video.play();

        },

        base64ToBlob(url) {
            fetch(url)
            .then(res => {
                return res.blob()
            })
            
        },

        uploadMediaFile2(storage, media, userId, postId) {
            this.loadingText = "Uploading media files...";
            return new Promise(function (resolve, reject) {

                //upload brand logos
                const storageRef = ref(storage, 'UserPosts/Media/' + userId + '/' + postId + '/' + media.name);
                const uploadTask = uploadBytesResumable(storageRef, media);

                //Update progress bar
                uploadTask.on('state_changed',
                    (snapshot) => {
                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        // console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case 'paused':
                                //console.log('Upload is paused');
                                break;
                            case 'running':
                                //console.log('Upload is running');
                                break;
                        }
                    },
                    (error) => {
                        switch (error.code) {
                            case 'storage/unauthorized':
                                // User doesn't have permission to access the object
                                break;
                            case 'storage/canceled':
                                // User canceled the upload
                                break;
                            case 'storage/unknown':
                                // Unknown error occurred, inspect error.serverResponse
                                this.errorText = "Unknown error occured";
                                this.$refs.loadingModal.classList.remove("bg-active");
                                this.$refs.errorModal.classList.add("bg-active");
                                console.log(error.serverResponse);
                                return;
                                break;
                        }
                    },
                    () => {
                        // Upload completed successfully, now we can get the download URL
                        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                            const postRef = doc(db, "UserPosts", postId);
                            await updateDoc(postRef, {

                                mediaList: arrayUnion({
                                    name: String(media.name),
                                    type: String(media.type),
                                    size: media.size,
                                    url: String(downloadURL),
                                }),

                            });

                            setTimeout(resolve, 2000);

                        });
                    });

                // Listen for state changes, errors, and completion of the upload.


            });

        },

        getMode() {

            if (localStorage.getItem("fbayz_mode") == null || localStorage.getItem("fbayz_mode") == '') {
                this.mode = 'light';
                localStorage.setItem("fbayz_mode", "light");
                return;
            }

            this.mode = localStorage.getItem("fbayz_mode");

            if (this.mode == "light") {
                document.body.classList.add("light");
                document.body.classList.remove("dark");
            }

            if (this.mode == "dark") {
                document.body.classList.add("dark");
                document.body.classList.remove("light");
            }


        },

        setToLight() {
            document.body.classList.add("light");
            document.body.classList.remove("dark");
            localStorage.setItem("fbayz_mode", "light");
            this.$router.go();
        },

        setToDark() {
            document.body.classList.remove("light");
            document.body.classList.add("dark");
            localStorage.setItem("fbayz_mode", "dark");
            this.$router.go();
        },

        async notiMethod() {

            const auth = getAuth();

            if(auth == null || sessionStorage.getItem("noUserName") == "noUserName"){
                return;
            }

            if(auth.currentUser.uid != null){
                this.notiSub = onSnapshot(doc(db, "Users", auth.currentUser.uid), (doc) => {
                    this.msgList = doc.data().msgList;
                    this.msgCount = this.msgList.length;
                    this.notiCount = doc.data().notiCount;
                });
            }



        },

        supportMail(){

            this.supportCount++;
            this.loadingText = "Sending message...";
            this.$refs.loadingModal.classList.add("bg-active");

            if(this.supportCount > 3){
                this.errorText = "Sending multiple messages in a row could be seen as spam. Your account could get flagged.";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            if(this.supportPhone == ""){
                this.supportPhone = "none";
            }

            //send mail
            axios.post('https://api.baesnap.com/v1/support-mail', {
                    toName: sessionStorage.getItem("fullName"),
                    toUsername: sessionStorage.getItem("userName"),
                    toEmail: sessionStorage.getItem("email"),
                    toPhone: this.supportPhone,
                    message: this.supportMessage
            })
            .then((response) => {
                
                this.successText = "Your message was sent successfully. We will get back to you soon."
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
                    
            })


        },

        page1(){
            this.$router.push({name: 'home'});
        },

        page2(){
            this.$router.push({name: 'notifications'});
        },

        page3(){
            this.$router.push({name: 'messages'});
        },

        page4(){
            this.$router.push({name: 'payments'});
        },

        handleScroll(){

            const currentScrollY = window.scrollY;

            /*
            * Don't do anything for tiny movements.
            * This prevents the navbar from constantly
            * flickering while scrolling.
            */

            if (
                Math.abs(currentScrollY - this.lastScrollY)
                < this.scrollThreshold
            ) {
                return;
            }

            /*
            * At the very top, always show navbar.
            */

            if (currentScrollY <= 20) {

                this.isNavHidden = false;

                this.lastScrollY = currentScrollY;

                return;

            }


            /*
            * Scrolling DOWN
            */

            if (currentScrollY > this.lastScrollY) {

                this.isNavHidden = true;

            }

            /*
            * Scrolling UP
            */

            else {

                this.isNavHidden = false;

            }


            this.lastScrollY = currentScrollY;

        },

        handleScrollx() {

            const currentScrollY = window.scrollY;

            const difference =
                currentScrollY - this.lastScrollY;


            /*
            * Always show at the top.
            */

            if (currentScrollY <= 20) {

                this.isNavHidden = false;

                this.lastScrollY = currentScrollY;

                return;

            }


            /*
            * Scrolling DOWN.
            */

            if (difference > 10) {

                this.isNavHidden = true;

                this.lastScrollY = currentScrollY;

                return;

            }


            /*
            * Scrolling UP.
            */

            if (difference < -10) {

                this.isNavHidden = false;

                this.lastScrollY = currentScrollY;

            }

        }

    }

}

</script>